// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content010_wrapper__OyuYQ","header":"Content010_header__0HtDm","blocks":"Content010_blocks__SsdqO","tabs":"Content010_tabs__TYqee"};